<button
  type="button"
  class="emese-launcher"
  [class.emese-launcher--hidden]="isLauncherHidden"
  (click)="openChat()"
  [attr.aria-label]="launcherAriaLabel"
>
  <span class="emese-launcher__avatar" aria-hidden="true">
    <img
      class="emese-launcher__icon"
      [src]="launcherImageSrc"
      [attr.alt]="launcherImageAlt"
      loading="lazy"
    />
  </span>
  <span class="emese-launcher__text-container" aria-hidden="true">
    <span class="emese-launcher__text">{{ launcherText }}</span>
  </span>
</button>
